import { useState } from "react";
import styles from "./styles.module.scss";
import img1 from "./img/1.png";
import img2 from "./img/2.png";
import img3 from "./img/3.png";
import img4 from "./img/4.png";
import img5 from "./img/5.png";
import img6 from "./img/6.png";


import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";



const data = [
  {
    value: "Withings",
    displayValue: "Withings",
    emoji: img1,
  },
  {
    value: "Fitbit",
    displayValue: "Fitbit",
    emoji: img2,
  },
  {
    value: "Renpho",
    displayValue: "Renpho",
    emoji: img3,
  },
  {
    value: "Eufy",
    displayValue: "Eufy",
    emoji: img4,
  },
  {
    value: "FitTrack",
    displayValue: "FitTrack",
    emoji: img5,
  },
    {
    value: "Other",
    displayValue: "Other",
    emoji: img6,
  },
];
export const KindScale = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = () => {
    onNextStep?.();
    onTrackEvent?.();
  };
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>What kind of smart scale do you have?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardWalky
              onClick={() => handleNextStep(value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.points}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
